import config from '../config';

export function newRequestId(): string {
	return crypto.randomUUID();
}

export function requestIdHeaders(requestId: string): Record<string, string> {
	return { [config.REQUEST_ID_HEADER]: requestId };
}
